// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `Body {
  margin: 0px;
}

.ScrollTable .ContentCard--body {
  overflow-x: auto;
}

.wait, .wait *{
	cursor: wait !important;   
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;CACC,uBAAuB;AACxB","sourcesContent":["Body {\n  margin: 0px;\n}\n\n.ScrollTable .ContentCard--body {\n  overflow-x: auto;\n}\n\n.wait, .wait *{\n\tcursor: wait !important;   \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
